import axios from "axios";
import { decryptAES, encryptAES } from "./encrypt";

// Check if encryption should be disabled (E2E testing mode)
const isEncryptionDisabled = process.env.REACT_APP_IS_E_E === "true";

// Create Axios instance
const api = axios.create({
  // baseURL: isEncryptionDisabled ? process.env.REACT_APP_CLIENT_API_URL : process.env.REACT_APP_API_Gateway,
  baseURL: process.env.REACT_APP_API_Gateway,
  headers: {
    "Content-Type": "application/json",
  },
});

// List of headers to encrypt
const headersToEncrypt = ["Password", "Userid", "Client-Code", "Partner-Code","partnerCode","clientCode"]; // Add the headers you want to encrypt here

// Request interceptor for encryption and logging
api.interceptors.request.use(
  (config) => {
    const isMultipart =
      config.headers["Content-Type"] &&
      config.headers["Content-Type"].includes("multipart/form-data");

    // Skip encryption if E2E mode is enabled
    if (isEncryptionDisabled) {
      return config;
    }

    // Encrypt body data if not multipart
    if (!isMultipart && config.data) {
      const encryptedData = encryptAES(config.data);
      config.data = encryptedData;
    }

    // Encrypt only allowed headers
    if (config.headers) {
      for (const header of headersToEncrypt) {
        if (config.headers[header]) {
          config.headers[header] = encryptAES(config.headers[header]);
        }
      }
    }

    return config;
  },
  (error) => {
    console.error("Request Error:", error);
    return Promise.reject(error);
  }
);

// Response interceptor for decryption and logging
api.interceptors.response.use(
  (response) => {
    // Skip decryption if E2E mode is enabled
    if (isEncryptionDisabled) {
      return response;
    }

    if (response.data) {
      const decryptedData = decryptAES(response.data);
      response.data = decryptedData;
    }
    return response;
  },
  (error) => {
    // Skip decryption if E2E mode is enabled
    if (isEncryptionDisabled) {
      return Promise.reject(error);
    }

    if (error.response && error.response.data) {
      const decryptedData = decryptAES(error.response.data);
      error.response.data = decryptedData;
    }
    return Promise.reject(error);
  }
);

export default api;
